import React from "react";
import Slider from 'react-slick';

function TopAirlines(){
    const airlineSlider = {
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        speed: 100,
        arrows: false,
        dots: false,
        loop:true,
        responsive: [{
             breakpoint: 1000,
             settings: {
                 slidesToShow: 3
             }
         }, 
         {
             breakpoint: 811,
             settings: {
                 slidesToShow: 2
            }
         }, 
         {
             breakpoint: 500,
             settings: {
                 slidesToShow: 2
             }
         }]
     };
    return(
        <>
        <section className="trending pb-0 topAirlines">
        <div className="container">
            <div className="row align-items-center justify-content-between">
                <div className="col-lg-12">
                    <div className="section-title mb-6 w-50 mx-auto text-center">
                        <h2 className="mb-1"><span style={{color: "#FF4778"}}>Top</span> <span className="theme">Airlines</span></h2>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="category-main-inner topAirlinesSlider">
                    <Slider {...airlineSlider} className="row side-slider">
                        <div className="col-lg-3 col-md-6 my-2">
                            <div className="category-item box-shadow p-1 py-1 text-center bg-white rounded overflow-hidden">
                                <div className="trending-topic-content">
                                    <img src={`${process.env.PUBLIC_URL}/assets/images/airline/BA.png`} className="mb-1 d-inline-block" alt="" />
                                    <h5>British Airways </h5>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 my-2">
                            <div className="category-item box-shadow  p-1 py-1 text-center bg-white rounded overflow-hidden">
                                <div className="trending-topic-content text-center">
                                    <img src={`${process.env.PUBLIC_URL}/assets/images/airline/TK.png`} className="mb-1 d-inline-block" alt="" />
                                    <h5>Turkish Airlines</h5>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 my-2">
                            <div className="category-item box-shadow  p-1 py-1 text-center bg-white rounded overflow-hidden">
                                <div className="trending-topic-content">
                                    <img src={`${process.env.PUBLIC_URL}/assets/images/airline/WB.png`} className="mb-1 d-inline-block" alt="" />
                                    <h5>Rwand Air </h5>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 my-2">
                            <div className="category-item box-shadow  p-1 py-1 text-center bg-white rounded overflow-hidden">
                                <div className="trending-topic-content">
                                    <img src={`${process.env.PUBLIC_URL}/assets/images/airline/VS.png`} className="mb-1 d-inline-block" alt="" />
                                    <h5>Virgin Atlantic </h5>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 my-2">
                            <div className="category-item box-shadow  p-1 py-1 text-center bg-white rounded overflow-hidden">
                                <div className="trending-topic-content">
                                    <img src={`${process.env.PUBLIC_URL}/assets/images/airline/SN.png`} className="mb-1 d-inline-block" alt="" />
                                    <h5>Brussels Airways </h5>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 my-2">
                            <div className="category-item box-shadow  p-1 py-1 text-center bg-white rounded overflow-hidden">
                                <div className="trending-topic-content">
                                    <img src={`${process.env.PUBLIC_URL}/assets/images/airline/QR.png`} className="mb-1 d-inline-block" alt="" />
                                    <h5>Qatar Airways </h5>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 my-2">
                            <div className="category-item box-shadow  p-1 py-1 text-center bg-white rounded overflow-hidden">
                                <div className="trending-topic-content">
                                    <img src={`${process.env.PUBLIC_URL}/assets/images/airline/KQ.png`} className="mb-1 d-inline-block" alt="" />
                                    <h5>Kenya Airlines </h5>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 my-2">
                            <div className="category-item box-shadow  p-1 py-1 text-center bg-white rounded overflow-hidden">
                                <div className="trending-topic-content">
                                    <img src={`${process.env.PUBLIC_URL}/assets/images/airline/LH.png`} className="mb-1 d-inline-block" alt="" />
                                    <h5>Lufthansa Airlines </h5>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 my-2">
                            <div className="category-item box-shadow  p-1 py-1 text-center bg-white rounded overflow-hidden">
                                <div className="trending-topic-content">
                                    <img src={`${process.env.PUBLIC_URL}/assets/images/airline/EK.png`} className="mb-1 d-inline-block" alt="" />
                                    <h5>Emirates Airlines </h5>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 my-2">
                            <div className="category-item box-shadow  p-1 py-1 text-center bg-white rounded overflow-hidden">
                                <div className="trending-topic-content">
                                    <img src={`${process.env.PUBLIC_URL}/assets/images/airline/KL.png`} className="mb-1 d-inline-block" alt="" />
                                    <h5>KLM</h5>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 my-2">
                            <div className="category-item box-shadow  p-1 py-1 text-center bg-white rounded overflow-hidden">
                                <div className="trending-topic-content">
                                    <img src={`${process.env.PUBLIC_URL}/assets/images/airline/EY.png`} className="mb-1 d-inline-block" alt="" />
                                    <h5>Etihad Airways </h5>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 my-2">
                            <div className="category-item box-shadow  p-1 py-1 text-center bg-white rounded overflow-hidden">
                                <div className="trending-topic-content">
                                    <img src={`${process.env.PUBLIC_URL}/assets/images/airline/AF.png`} className="mb-1 d-inline-block" alt="" />
                                    <h5>Air France </h5>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 my-2">
                            <div className="category-item box-shadow  p-1 py-1 text-center bg-white rounded overflow-hidden">
                                <div className="trending-topic-content">
                                    <img src={`${process.env.PUBLIC_URL}/assets/images/airline/PK.png`} className="mb-1 d-inline-block" alt="" />
                                    <h5>Pakistan International Airlines </h5>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 my-2">
                            <div className="category-item box-shadow  p-1 py-1 text-center bg-white rounded overflow-hidden">
                                <div className="trending-topic-content">
                                    <img src={`${process.env.PUBLIC_URL}/assets/images/airline/LX.png`} className="mb-1 d-inline-block" alt="" />
                                    <h5>Swiss Airlines </h5>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 my-2">
                            <div className="category-item box-shadow  p-1 py-1 text-center bg-white rounded overflow-hidden">
                                <div className="trending-topic-content">
                                    <img src={`${process.env.PUBLIC_URL}/assets/images/airline/DL.png`} className="mb-1 d-inline-block" alt="" />
                                    <h5>Delta Airlines </h5>
                                </div>
                            </div>
                        </div>
                    </Slider>
                </div>
            </div>
        </div>
    </section>        
        </>
    )
}
export default TopAirlines;